import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18next from 'i18next'
import Drawer from '@material-ui/core/Drawer'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import PropTypes from 'prop-types'
import styles from '../../styles/request.module.css'
import * as StatusSurvey from '../../scripts/StatusSurveyCode'

const useStyles = makeStyles(theme => ({
    toolBar: {
        alignSelf: 'flex-end',
        color: "var(--color1) !important"
    },
    buttonFilter: {
        marginTop: '10px',
    },
    divLabelStatus: {
        textAlign: 'center',
        borderBottom: '1px solid #cccccc',
        marginBottom: '10px'
    },
    divFilter: {
        position: 'fixed',
        display: 'flex',
        left: '10px',
        right: '10px',
        top: '50px',
        zIndex: '1',
        backgroundColor: '#ffffff'
    },
    divHeaderToolbar: {
        marginTop: '20px',
        '@media (max-width: 600px)': {
            marginTop: '13px'
        }
    }
}));

function FilterSurvey(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [listFilter, setListFilter] = React.useState([]);
    const [statusValue, setStatusValue] = React.useState({ "O" : true });

    const { handleFilter } = props;

    useEffect(() => {
        loadPage();
    }, [])

    const loadPage = async () => {
        await loadFilter();
    }

    const loadFilter = async () => {
        return new Promise(resolve => {
            var list = [
                {
                    key: i18next.t('survey:status.opened'),
                    value: StatusSurvey.Status_Opened
                },
                {
                    key: i18next.t('survey:status.completed'),
                    value: StatusSurvey.Status_Completed
                },
                {
                    key: i18next.t('survey:status.expired'),
                    value: StatusSurvey.Status_Expired
                }
            ];
            setListFilter(list);

            resolve();
        })
    }

    const handleOpenFilter = () => {
        setOpen(true);
    }

    const handleFilterSubmit = () => {
        handleFilter(statusValue);

        setOpen(false);
    }

    //const handleStatusValue = () => {
    //    const arrayValue = [];

    //    if (status.opened) {
    //        arrayValue.push(leaveRequestStatusCode.Status_Opened);
    //    }
    //    if (status.closed) {
    //        arrayValue.push(leaveRequestStatusCode.Status_Close);
    //    }
    //    if (status.canceled) {
    //        arrayValue.push(leaveRequestStatusCode.Status_Canceled);
    //    }
    //    if (status.cancelationRequest) {
    //        arrayValue.push(leaveRequestStatusCode.Status_Cancel_Request);
    //    }

    //    setStatusValue(arrayValue);
    //}

    const toggleDrawer = (open) => (event) => {
        // This is to avoid the drawer to close when we click within the filter div
        const role = event.currentTarget.attributes.role;
        if (role !== undefined && role.value === 'filter') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const list = (
        <div
            role="filter"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <div className={classes.divLabelStatus}>{i18next.t('survey:labelStatus')}</div>
            {listFilter.map((obj, index) => (
                <React.Fragment key={index}>
                    <FormControl key={index} className={styles.itemsFilter}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={statusValue[obj.value] == true}
                                    onChange={(event) => onChangeFilter(event, obj.value)}
                                    name={`filter-${obj.value}`}
                                    variant="success"
                                />
                            }
                            label={obj.key}
                            labelPlacement="end"
                        />
                    </FormControl>
                </React.Fragment>
            ))}
        </div>
    );

    const onChangeFilter = (event, value) => {
        setStatusValue({
            ...statusValue,
            [value]: event.target.checked
        });
    }

    return (
        <div id="divFilterSurvey" className={classes.divFilter}>
            <React.Fragment>
                <AppBar position="static" className={classes.divHeaderToolbar}>
                    <Toolbar className={classes.toolBar}>
                        <Button startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="inherit" onClick={handleOpenFilter}>{i18next.t('survey:filter.button')}</Button>
                    </Toolbar>
                </AppBar>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)}>
                    {list}
                    <Button className={styles.buttonFilter} startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="primary" onClick={handleFilterSubmit}>{i18next.t('survey:filter.button')}</Button>
                </Drawer>
            </React.Fragment>
        </div>
    );
}

export default withNamespaces(['survey'], { wait: true })(FilterSurvey);

FilterSurvey.propTypes = {
    handleFilter: PropTypes.func.isRequired
}